export const csrfHeaders = () => {
  const encoded = document.cookie
    .split("; ")
    .find((row) => row.startsWith("md-csrf="))
    ?.split("=")
    .slice(1)
    .join("=") ?? "";
  return { "x-csrf-token": decodeURIComponent(encoded) };
};
